import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { AccountService, FilesService, PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { ImageSizeEnum, ReviewListItem } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiCover } from 'onclass-ui';

@Component({
  selector: 'app-meeting-reviews-2',
  templateUrl: './meeting-reviews-2.component.html',
  styleUrls: ['./meeting-reviews-2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingReviews2Component extends ChangableComponent implements OnInit {
  deviceService = inject(DeviceDetectorService);
  protected readonly platform = inject(PlatformService);

  @Input() set review(review: ReviewListItem) {
    this._review = review;
    this.prepare();
  }

  public get review() {
    return this._review;
  }

  public fullName: string;
  public avatar: OnUiCover;
  public reporterRoute: string[];
  public reviewDate: Date;
  private _review: ReviewListItem;

  ngOnInit(): void {}

  public prepare() {
    this.reviewDate = new Date(this._review.updatedAt);
    this.reporterRoute = AccountService.accountRoute({ slug: this._review.reporterSlug });
    this.avatar = {
      type: 'avatar',
      img: FilesService.getFileUrlBySize(this._review.reporterPicId, ImageSizeEnum.sm),
      title: this._review.reporterName,
      link: this.reporterRoute.join('/'),
      form: 'circle',
    };
    this.detectChanges();
  }

  public trackByFn(index) {
    return index;
  }
}
